import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_CAREGIVER_CONSENT_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  UpdateCaregiverToFullConsentPayload,
  UpdateCaregiverToFullConsentResult,
} from '../types/updateCaregiverToFullConsent.types';

export const updateCaregiverToFullConsent = (builder: BuilderType) =>
  builder.mutation<UpdateCaregiverToFullConsentResult, UpdateCaregiverToFullConsentPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: UPDATE_CAREGIVER_CONSENT_URL,
    }),
    transformResponse: (response: GenericApiResponse<UpdateCaregiverToFullConsentResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
